import React, { Fragment } from "react";
import insta from "../../assets/icons/6477177f35f159fa24b47bec_gram-icon.png";
import faceBook from "../../assets/icons/6477171249031242bba7a3a7_fb-icon.png";
import { Link } from "react-router-dom";

const Social = () => {
  return (
    <Fragment>
      <div
        className="flex flex-col items-end justify-center gap-[25px] absolute top-[250px] right-5 z-[99] "
        data-aos="fade-left"
      >
        <Link to="https://www.instagram.com/luster_photobooth/">
          <img src={insta} alt="Instagram" className=" hover:scale-110 transition-transform duration-300" />
        </Link>
        <Link to="https://www.facebook.com/profile.php?id=100064348793272&mibextid=ZbWKwL">
          <img src={faceBook} alt="Facebook" className=" hover:scale-110 transition-transform duration-300" />
        </Link>
      </div>
    </Fragment>
  );
};

export default Social;
